import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blueA14",
  "use": "icon-blueA14-usage",
  "viewBox": "0 0 10 6.155",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6.155\" id=\"icon-blueA14\">\r\n  <rect id=\"icon-blueA14_矩形_3278\" data-name=\"矩形 3278\" width=\"7.071\" height=\"1.634\" rx=\"0.5\" transform=\"translate(10 1.155) rotate(135)\" fill=\"#4c8afc\" />\r\n  <rect id=\"icon-blueA14_矩形_3279\" data-name=\"矩形 3279\" width=\"7.07\" height=\"1.63\" rx=\"0.5\" transform=\"translate(1.152 0.002) rotate(45)\" fill=\"#4c8afc\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol